import React, { useRef, useState} from "react";
import {useTheme} from "styled-components";
import { AccountWrapper, ShimmerLogin } from "./styles.styled";
import DropdownArrowIcon from "assets/icons/dropdownIconSVG";
import {useOnClickOutside} from "hooks/useOnClickOutside";
import {
  gtmDownloadApp,
  gtmLanguageBtn,
  gtmLoginTopBarBtn,
} from "GTMs/actions/commonActions";
import IconAccount from "assets/icons/IconAccount";
import IconMyPosts from "assets/icons/IconMyPosts";
import {classNames} from "helpers/themeHelpers";
import HomeIcon from "assets/icons/homeIcon";
import IconChat from "assets/icons/IconChat";
import IconNotification from "assets/icons/IconNotification";
import IconDownArrowHead from "assets/icons/IconDownArrowHead";
import IconServices from "assets/icons/IconServices";
import {linkToMyOS} from "helpers/links-builders/linkToMyOS";
import IconChangeLanguage from "assets/icons/IconChangeLanguage";
import IconLogOut from "assets/icons/IconLogOut";
import Image from "componentReusable/Image";
import downloadAppsLink from "config/JSON/DownloadPage/downloadAppLinkMobile.json";
import {useLink2} from "contexts/SeoContext";
import SwitchLangAnchor from "componentReusable/SwitchLangAnchor";
import { useSsoContext} from "contexts/authSSOContext";
import {isChatEnabled, isShobiddak} from "helpers/osHelpers";
import {handleLoggingAuthenticate} from "../../../../../libs/logging/helpers/shareLogging";
import {EnumWidgets} from "../../../../../libs/logging/types/loggingTypes";
import {MyProfileLinks} from "helpers/links-builders/myProfileLinks";

const HeaderTwoLoggedInDesktop = () => {
  const { translations, country} = useTheme();
  const { isLoggedInSso ,loggedInToken , logout , userInfo ,showShimmer } = useSsoContext();
  const [open, setOpen] = useState<boolean>(false);
  const [isActive, setIsActive] = useState({status: false, id: null});
  const {googlePlayStore, appleStore, huaweiStore} = downloadAppsLink.footer;
  const link2 = useLink2();

  const handleOnLogoutClick = async () => {
    await logout();
    closeDropDown();
    document.dispatchEvent(
        new CustomEvent("on-logout-success", {
          detail: {},
        })
    );
  };

  const containerRef = useRef<any>();
  const closeDropDown = () => {
    setOpen(false);
    setIsActive({status: false, id: null});
  };
  useOnClickOutside(containerRef, closeDropDown);

  if (showShimmer)
    return (
        <ShimmerLogin className="p-8 grayBg shimmerEffect" />
    )

  if (!isLoggedInSso)
    return (
        <button className="p-8 ms-8 loginBtn whiteBtn width-auto font-20"
                onClick={() => {
                    handleLoggingAuthenticate({
                        currentWidgetName: EnumWidgets.HEADER});
                  gtmLoginTopBarBtn();
                  loggedInToken().then()
                }}>
          <IconAccount
              fill="#0061fe"
              className="inline vMiddle me-8"
              width={"17.5"}
              height={"17.5"}
          />
          {translations?.login}
        </button>
    );

  const name =
      userInfo?.full_name !== undefined ? userInfo?.full_name : "Guest";

  const handleClick = (id) => {
    if (id == isActive.id) {
      setIsActive({status: false, id: null});
    } else {
      setIsActive({status: true, id});
    }
  };


  return (
      <AccountWrapper id="userMenu" className="relative ms-16" ref={containerRef}>
        <div onClick={() => setOpen(!open)} className="flex pointer">
          <DropdownArrowIcon width="30" height="30"/>
          <div className="font-14 alignSelfCenter me-8">
            {userInfo?.full_name}
          </div>
          {userInfo?.profile_picture && (
              <img
                  src={userInfo?.profile_picture}
                  alt={userInfo?.full_name}
                  width="30"
                  height="30"
                  className="fullRadius"
              />
          )}
        </div>

        {open && (
            <div id="accountMenu" className="absolute whiteBg radius-8 mt-8">
              <div className="p-8">
                <a
                    href={linkToMyOS(MyProfileLinks.myAccount.link)}
                    target="_blank"
                    className="flex flexSpaceBetween p-8 alignItems blackColor radius-8"
                >
                  <div className="flex">
                    <img
                        src={userInfo?.profile_picture}
                        alt={userInfo?.full_name}
                        width="37"
                        height="37"
                        className="radius-8"
                    />

                    <div className="ms-8 pt-8 breakWord">
                      <strong className="block mb-8">{name}</strong>
                      <div className="block mb-8 font-14">
                        {userInfo?.phone_number}
                      </div>
                      <div className="font-15 membership_type center bold radius-8">
                        {" "}
                        {userInfo?.member_type === 0 && translations.free }{" "}
                        {userInfo?.member_type === 1 &&  translations.shop }{" "}
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="accountList ps-8 pe-8">
                <a
                    href={linkToMyOS(MyProfileLinks.myHome.link)}
                    target="_blank"
                    className="flex p-8 mb-8 alignItems radius-8"
                >
              <span className="center">
                <HomeIcon fill="#000" className="inline vMiddle"/>
              </span>
                  {translations.footer.home}
                </a>

                {isChatEnabled(country) && <a
                href={linkToMyOS(MyProfileLinks.myChats.link)}
                target="_blank"
                className="flex p-8 mb-8 alignItems radius-8"
            >
              <span className="center">
                {" "}
                <IconChat className="inline vMiddle"/>
              </span>
                  {translations.myChats}
                </a>}
                <a
                    href={linkToMyOS(MyProfileLinks.myNotifications.link)}
                    target="_blank"
                    className="flex p-8 mb-8 alignItems radius-8"
                >
              <span className="center">
                <IconNotification
                    width="22"
                    height="22"
                    className="inline vMiddle"
                />
              </span>
                  {translations.myProfileList.myNotifications}
                </a>
                <div
                    {...classNames(
                        "subMenuTitle flex p-8 mb-8 alignItems flexSpaceBetween radius-8 pointer",
                        isActive.id == "button1" && "selected"
                    )}
                    onClick={() => handleClick("button1")}
                >
                  <div className="flex alignItems">
                <span className="center">
                  {" "}
                  <IconMyPosts
                      width="16"
                      height="22"
                      className="inline vMiddle"
                  />
                </span>
                    {translations.myProfileList.ads}
                  </div>
                  <IconDownArrowHead
                      fill="#000"
                      {...classNames(
                          "subMenuArrow",
                          isActive.status && isActive.id == "button1" && "rotateUp"
                      )}
                  />
                </div>
                {isActive.status && isActive.id == "button1" && (
                    <div className="subList flex flexDirectionColumn">
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myAds.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.myAdsList}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myDraft.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.archive}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myFavAds.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.myFavAds}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myRecentlyViewed.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.viewedAds}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myAdsFollowings.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.adsFromFollowing}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myJobApplications.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.ordersJobs}
                      </a>
                      <a
                          className="p-8 radius-8mb-8"
                          href={linkToMyOS(MyProfileLinks.mySavedSearch.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.favSearches}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myRecentSearch.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.viewedSearches}
                      </a>
                    </div>
                )}

                <div
                    {...classNames(
                        "subMenuTitle flex p-8 mb-8 alignItems flexSpaceBetween radius-8 pointer",
                        isActive.id == "button2" && "selected"
                    )}
                    onClick={() => handleClick("button2")}
                >
                  <div className="flex alignItems radius-8">
                    {" "}
                    <span className="center">
                  {" "}
                      <IconAccount fill="#000" className="inline vMiddle"/>
                </span>
                    {translations.myProfileList.account}
                  </div>
                  <IconDownArrowHead
                      fill="#000"
                      {...classNames(
                          "subMenuArrow",
                          isActive.status && isActive.id == "button2" && "rotateUp"
                      )}
                  />
                </div>
                {isActive.status && isActive.id == "button2" && (
                    <div className="subList flex flexDirectionColumn radius-8">
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myAccount.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.myAccount}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myCv.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.myJobProfile}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myRating.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.myRate}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myWallet.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.myWallet}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myFollowers.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.followers}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.myAccountFollowing.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.followings}
                      </a>
                      <a
                          className="p-8 radius-8 mb-8"
                          href={linkToMyOS(MyProfileLinks.mySettings.link)}
                          target="_blank"
                      >
                        {translations.myProfileList.settings}
                      </a>
                    </div>
                )}
                <a
                    href={linkToMyOS(MyProfileLinks.myProducts.link)}
                    target="_blank"
                    className="flex p-8 mb-8 alignItems radius-8"
                >
              <span className="center">
                {" "}
                <IconServices className="inline vMiddle"/>
              </span>
                  {translations.myProfileList.services}
                </a>

                <a
                    href={linkToMyOS(MyProfileLinks.myInviteFriends.link)}
                    target="_blank"
                    className="flex p-8 mb-8 alignItems radius-8"
                >
              <span className="center">
                {" "}
                <IconNotification
                    width="22"
                    height="22"
                    className="inline vMiddle"
                />
              </span>
                  {translations.myProfileList.inviteYourFriends}
                </a>
                <SwitchLangAnchor
                    href={link2}
                    className="flex p-8 mb-8 alignItems flexSpaceBetween radius-8"
                    onClick={gtmLanguageBtn}
                >
              <span className="flex alignItems ">
                {" "}
                <IconChangeLanguage fill="#000" className="inline vMiddle"/>
                {translations.footer.language}
              </span>
                  <div className="p-8 black lightGrayBg radius-8">
                    {translations.language}
                  </div>
                </SwitchLangAnchor>
                <button
                    className="flex p-8 alignItems width-100"
                    key={translations.logout}
                    onClick={handleOnLogoutClick}
                >
              <span className="center">
                <IconLogOut color="#000" className="inline vMiddle"/>
              </span>
                  {translations.logout}
                </button>
              </div>

              <div className="p-8" id="myListFooter">
                <div className="width-100 borderTop pt-16">
                  <strong className="block">
                    {translations.downloadAppPage.downloadOpenSooqApp}
                  </strong>
                  <div className="flex mt-16">
                    <a
                        href={googlePlayStore}
                        onClick={() => gtmDownloadApp("Android")}
                        aria-label="Download App"
                        className="me-8"
                    >
                      <Image
                          src="/images/downloadAppButtons/googlePlay.png"
                          width="177"
                          height="51"
                          className="width-100 height-auto"
                          alt="Google Play"
                          loading="lazy"
                      />
                    </a>
                    <a
                        href={appleStore}
                        onClick={() => gtmDownloadApp("iOS")}
                        aria-label="Download App"
                        className="me-8"
                    >
                      <Image
                          src="/images/downloadAppButtons/appStore.png"
                          width="161"
                          height="51"
                          className="width-100 height-auto"
                          alt="App Store"
                          loading="lazy"
                      />
                    </a>
                    <a
                        href={huaweiStore}
                        onClick={() => gtmDownloadApp("Huawei")}
                        aria-label="Download App"
                    >
                      <Image
                          src="/images/downloadAppButtons/appGallery.png"
                          width="177"
                          height="51"
                          className="width-100 height-auto"
                          alt="App Gallery"
                          loading="lazy"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
        )}
      </AccountWrapper>
  );
};

export default HeaderTwoLoggedInDesktop;
